/* Delegated handlers also work after Shopify replaces a section in the editor. */
(() => {
  const root = () => window.Shopify?.routes?.root || window.awShopify?.root || '/';
  const ready = variant => Boolean(variant?.available && variant.price > 0 && variant.inventory > 0);
  function variants(section) {
    try { return JSON.parse(section.querySelector('[data-aw-native-variants]')?.textContent || '[]'); }
    catch { return []; }
  }
  function selection(section) {
    return variants(section).find(v => String(v.id) === section.querySelector('[name=id]')?.value);
  }
  function update(section) {
    if (!section) return;
    const variant = selection(section), quoteOnly = section.dataset.awQuoteOnly === 'true', available = !quoteOnly && ready(variant);
    const priceText = quoteOnly ? 'Price on Enquiry' : (variant?.price > 0 ? variant.money : section.dataset.pendingPrice);
    section.querySelectorAll('[data-aw-native-price]').forEach(price => { price.textContent = priceText; });
    const sku = section.querySelector('[data-aw-native-sku]');
    if (sku) sku.textContent = variant?.sku || '';
    const add = section.querySelector('[data-aw-native-add]');
    if (add) { add.hidden = !available; add.disabled = !available; }
    section.querySelectorAll('[data-aw-native-enquiry],[data-aw-native-availability]').forEach(el => { el.hidden = available; });
    const image = section.querySelector('.main-product-image img');
    if (image && variant?.image && !section.classList.contains('aw-launch-page')) { image.removeAttribute('srcset'); image.src = variant.image; }
    const enquiry = section.querySelector('[data-aw-native-enquiry]');
    if (enquiry && variant && !quoteOnly) {
      const url = new URL(enquiry.href, location.origin);
      url.searchParams.set('aw_variant', variant.title || '');
      url.searchParams.set('aw_sku', variant.sku || '');
      enquiry.href = url.pathname + url.search + url.hash;
    }
  }
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-aw-native-variant]')) return;
    const section = event.target.closest('[data-aw-native-product]');
    update(section);
    if (!window.Shopify?.designMode) {
      const url = new URL(location.href); url.searchParams.set('variant', event.target.value);
      history.replaceState({}, '', url);
    }
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-aw-native-gallery]');
    if (!button) return;
    const image = button.closest('[data-aw-native-product]')?.querySelector('.main-product-image img');
    if (image) { image.removeAttribute('srcset'); image.src = button.dataset.awNativeGallery; }
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('.aw-native-product-form');
    if (!form) return;
    event.preventDefault();
    const section = form.closest('[data-aw-native-product]'), variant = selection(section);
    if (section.dataset.awQuoteOnly === 'true' || !ready(variant) || window.Shopify?.designMode) return;
    const button = form.querySelector('[data-aw-native-add]');
    const requestedQuantity = Number(form.querySelector('[name=quantity]')?.value || 1);
    const quantity = Number.isFinite(requestedQuantity) ? Math.max(1, Math.min(99, Math.floor(requestedQuantity))) : 1;
    if (button) button.disabled = true;
    try {
      const response = await fetch(root() + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items:[{id:variant.id,quantity}]})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this option.');
      location.assign(root() + 'cart' + (new URLSearchParams(location.search).get('preview_theme_id') ? '?preview_theme_id=' + new URLSearchParams(location.search).get('preview_theme_id') : ''));
    } catch (error) {
      const notice = section.querySelector('[data-aw-native-availability]');
      if (notice) { notice.hidden = false; notice.setAttribute('role','alert'); notice.textContent = error.message; }
      if (button) button.disabled = false;
    }
  });
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-aw-native-product]').forEach(update);
  });
})();

